import React, {useEffect, useState} from 'react';
import {Button, Modal, Select} from "react-materialize";

import EditOptions from "../EditOptions.react";
import TBInput from "../../Commons/Input.react";
import useFetch from "../../../Utilities/API/useFetch.react";
import {TableCell, TableRow} from "../../Commons/TBTable.react";

const AuthUser = ({user, authRoles, index, showActions}) => {
  const [fetchUrl] = useFetch();
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState(null);
  const [email, setEmail] = useState(null);
  const [roles, setRoles] = useState([]);
  const [editing, setEditing] = useState(false);

  useEffect(() => {
    setName(user.name);
    setEmail(user.email);
    let rolesArr = user.roles.map((role) => role.name);
    setRoles(rolesArr)
  }, [user])

  const handleChange = (event) => {
    if (event.target.name === 'name') {
      setName(event.target.value);
    }
    if (event.target.name === 'email') {
      setEmail(event.target.value);
    }
  }

  const handleSelect = (target) => {
    let newRoles = target.value.length > 1 ? target.value.split(', ') : [target.value];
    setRoles(newRoles);
  }

  const handleDelete = () => {
    console.log('delete user')
    // handleAction('DELETE_USER', user);
  }

  const handleEdit = () => {
    setEditing(!editing);
  }

  const handleSave = async () => {
    setLoading(true);
    // todo: filter this so it just pushes the ids
    let updatedRoles = authRoles.filter((role) => roles.includes(role.name));
    let updatedUser = {...user, name: name, email: email, roles: updatedRoles}
    await fetchUrl('editAuthUser', updatedUser);
    setLoading(false);
  }

  return (
    <>
      { editing &&
        <Modal
          header={'Edit User'}
          open={editing}
          preventScrolling={true}
          options={{
            onCloseEnd: () => { handleEdit()},
          }}
          actions={[
            <Button onClick={handleEdit} flat modal={'close'} node={'button'} waves={'green'}>Cancel</Button>,
            <Button onClick={handleSave} flat modal={'close'} node={'button'} waves={'green'}>Save User</Button>
          ]}
        >
          <TBInput name={'name'} label={'Name'} placeholder={name} value={name} handleChange={handleChange}/>
          <TBInput name={'email'} label={'Email'} placeholder={email} value={email} handleChange={handleChange}/>
          <Select
            id={'user-roles-select'}
            multiple
            name={'select'}
            label={'Roles'}
            options={{
              classes: '',
              dropdownOptions: {
                alignment: 'left',
                autoTrigger: true,
                closeOnClick: true,
                constrainWidth: true,
                coverTrigger: true,
                hover: false,
                inDuration: 150,
                onCloseEnd: handleSelect,
                onCloseStart: null,
                onOpenEnd: null,
                onOpenStart: null,
                outDuration: 250
              }
            }}
            value={roles}
          >
            {
              authRoles && authRoles?.map((role) => {
                return <option value={role.name}>{role.name}</option>
              })
            }
          </Select>
        </Modal>
      }
      <TableRow index={index}>
        <TableCell>{name}</TableCell>
        <TableCell>{email}</TableCell>
        <TableCell width={'50%'}>
          {
            roles.length > 1 ?
              roles.map((role) => {return <p>{role}</p>}) :
              roles[0]
          }
        </TableCell>
        {
          showActions &&
            <TableCell textAlign={'right'} width={'16%'}>
              <EditOptions hoverColor={'white'} handleEdit={handleEdit} handleDelete={handleDelete}/>
            </TableCell>
        }
      </TableRow>
    </>
  )
}

export default AuthUser;